var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.498 16C13.4297 16 13.3646 15.987 13.3027 15.9609C13.2441 15.9349 13.1921 15.8991 13.1465 15.8535C13.1009 15.8079 13.0651 15.7559 13.0391 15.6973C13.013 15.6354 13 15.5703 13 15.502C13 15.4336 13.013 15.3701 13.0391 15.3115C13.0651 15.2497 13.1009 15.196 13.1465 15.1504C13.1921 15.1016 13.2441 15.0641 13.3027 15.0381C13.3646 15.012 13.4297 14.999 13.498 14.999H22.502C22.5703 14.999 22.6338 15.012 22.6924 15.0381C22.7542 15.0641 22.8079 15.1016 22.8535 15.1504C22.8991 15.196 22.9349 15.2497 22.9609 15.3115C22.987 15.3701 23 15.4336 23 15.502C23 15.5703 22.987 15.6354 22.9609 15.6973C22.9349 15.7559 22.8991 15.8079 22.8535 15.8535C22.8079 15.8991 22.7542 15.9349 22.6924 15.9609C22.6338 15.987 22.5703 16 22.502 16H13.498Z",
    fill: "black",
    fillOpacity: 0.8956
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.a2b8bf88a98c8f69a1b9767c7376a64f.svg";
export { ForwardRef as ReactComponent };